export var ButtonType;
(function (ButtonType) {
    ButtonType["Default"] = "default";
    ButtonType["Outline"] = "outline";
    ButtonType["FullWidth"] = "fullWidth";
    ButtonType["ThinOutline"] = "thinOutline";
})(ButtonType || (ButtonType = {}));
